// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"ss_a bhi_a bhi_r bhi_j","Photos__img":"ss_b bhi_b"};